// Cette valeur est modifiée lors du build
export const APP_VERSION_VALUE = '20250619.0.0-50a7dfa0da'
export const BFF_KEY_VALUE = 'ah1MPO-izehIHD-QZZ9y88n-kku876'
